module.exports = __webpack_public_path__ + "images/illustrations/alert.svg";